// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Input_wrap__1N7eV","input":"Input_input__3rPb3"};